// callback.component.ts
import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../material.module';
import { AuthService } from '@auth-suite-services/services';

@Component({
  selector: 'app-callback',
  standalone: true,
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  imports: [MaterialModule]
})
export class CallbackComponent implements OnInit {
  // Removed login success sound 28/10/2026 DW
  constructor(public authService: AuthService) {
    console.log('callback');
    this.authService.handleAuthCallback();
  }

  ngOnInit(): void {
  }
}
